import React, { useEffect, useState } from 'react';
import { downloadTerms } from '../utils/downloadTerms';
export const Questionnaire = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [countdown, setCountdown] = useState(5);
  const [hasAgreed, setHasAgreed] = useState(false);
  useEffect(() => {
    console.log('Questionnaire component mounted');
    const countdownTimer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownTimer);
          setIsLoading(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(countdownTimer);
  }, []);
  const scrollToWaitlistForm = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (isLoading) {
    return <section className="py-20 bg-white" data-id="element-51">
        <div className="max-w-4xl mx-auto px-4" data-id="element-52">
          <div className="text-center" data-id="element-53">
            <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-54">
              Loading Survey...
            </div>
            <div className="text-6xl font-bold text-blue-600 mb-4" data-id="element-55">
              {countdown}
            </div>
            <div className="text-lg text-gray-600" data-id="element-56">
              Please wait while we prepare your questionnaire
            </div>
          </div>
        </div>
      </section>;
  }
  return <section className="py-12 bg-white" data-id="element-57">
      <div className="max-w-4xl mx-auto px-4" data-id="element-58">
        <div className="text-center mb-8" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-60">
            Help us understand your needs
          </h2>
          <p className="text-lg text-gray-600" data-id="element-61">
            A few quick questions to get to know you better
          </p>
        </div>

        {/* Terms & Conditions Consent */}
        <div className="flex items-start gap-3 mb-6 max-w-xl mx-auto bg-gray-50 rounded-xl p-4 border border-gray-200" data-id="element-62">
          <input type="checkbox" id="terms-consent" checked={hasAgreed} onChange={e => setHasAgreed(e.target.checked)} className="mt-1 h-5 w-5 rounded border-gray-300 text-black focus:ring-black cursor-pointer flex-shrink-0" data-id="element-63" />
          <label htmlFor="terms-consent" className="text-sm text-gray-700 cursor-pointer leading-relaxed" data-id="element-64">
            I have read and agree to the{' '}
            <button onClick={e => {
            e.preventDefault();
            downloadTerms();
          }} className="text-black font-semibold underline hover:text-gray-700 transition-colors bg-transparent border-none cursor-pointer p-0 inline" data-id="element-65">
              Terms & Conditions
            </button>
          </label>
        </div>

        {/* Embedded Typeform */}
        <div className="relative w-full h-[500px] rounded-2xl overflow-hidden shadow-lg mb-12 border border-gray-100" data-id="element-66">
          {!hasAgreed && <div className="absolute inset-0 z-10 bg-white/80 backdrop-blur-sm flex items-center justify-center" data-id="element-67">
              <div className="text-center p-8" data-id="element-68">
                <p className="text-gray-500 text-lg font-medium" data-id="element-69">
                  Please agree to the Terms & Conditions above to access the
                  survey
                </p>
              </div>
            </div>}
          <iframe src="https://jkjgwzh5it9.typeform.com/to/a6awsFHV" width="100%" height="100%" frameBorder="0" style={{
          border: 'none'
        }} title="Questionnaire Form" onLoad={() => console.log('Typeform iframe loaded')} data-id="element-70" />
        </div>
      </div>
    </section>;
};